import { render } from "./EndTest.vue?vue&type=template&id=5544494e"
import script from "./EndTest.vue?vue&type=script&lang=js"
export * from "./EndTest.vue?vue&type=script&lang=js"

import "./EndTest.vue?vue&type=style&index=0&id=5544494e&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__